import { LoadingStatuses } from 'core/common/entities';

export type SupportState = {
  loadingStatus: LoadingStatuses;
};

export const supportInitialState: SupportState = {
  loadingStatus: LoadingStatuses.IDLE,
};
